import styled, { css } from 'styled-components';

export const hideScrollbarMixin = css`
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  &::-webkit-scrollbar {
    /* WebKit */
    height: 0;
    width: 0;
  }
`;
const HorizontalScrollableList = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: scroll;
  position: relative;
  ${hideScrollbarMixin};
`;

export default HorizontalScrollableList;
